var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"pt-0 mt-0",attrs:{"dense":"","inset":"","hide-details":"","label":_vm.$t(`${_vm.labelTranslationPrefix}${_vm.translationValue}`),"true-value":_vm.trueValue,"false-value":_vm.falseValue,"disabled":_vm.disabled},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }